import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Transition({ children, trigger, type }) {
  return (
    <Lib.Transition trigger={trigger} type={type}>
      { children }
    </Lib.Transition>
  )
}

Transition.defaultProps = {
  trigger: true,
  type: 'collapse',
}

Transition.propTypes = {
  children: PropType.node.isRequired,
  trigger: PropType.bool,
  type: PropType.oneOf(['collapse']),
}

export default Transition
